import { useContext, useState } from "react";

import { Menu, Seo } from "~components";
import { BaseContext } from "~context";

import { Layout } from "~components/common/Layout";
import { SubHeader } from "~components/overall";
import * as useEventsService from "~features/events/hooks/useEventsService";
import { MembershipsDocument } from "~graphql/typed-document-nodes";
import { useQuery } from "~hooks/useQuery";
import { List } from "~components/events/events.List";
import { EventCardProps } from "~components/events";

const Overall = () => {
  const { organization } = useContext(BaseContext);
  const [showSearch, setShowSearch] = useState(false);
  const [search, setSearch] = useState<string>(undefined);

  const {
    events,
    featuredEvents,
    isLoading,
    error,
  } = useEventsService.useEventsService({
    search,
    includeFeaturedEvents: true,
  });

  const {
    data: membershipData,
    error: membershipsError,
    isLoading: membershipsLoading,
  } = useQuery(MembershipsDocument);

  const memberships = membershipData?.memberships.edges.map(({ node }) => node);

  const overall: EventCardProps[] = [];

  if (memberships?.length > 0) {
    memberships.forEach((membership) =>
      overall.push({
        type: "membership",
        eventKind: membership.membershipKind,
        logo: membership.banner || membership.thumbnail,
        startDate: membership.startDate,
        endDate: membership.endDate,
        title: membership.name,
        id: membership.id,
        hasPublicRelease: true,
        venue: membership.venue,
        timeZone: membership.venue?.timezone,
        locale: membership.venue?.locale,
      })
    );
  }

  if (events?.length > 0) {
    events.forEach((event) =>
      overall.push({
        type: "event",
        logo: event.logo,
        eventKind: event.eventKind,
        startDate: event.startDate,
        endDate: event.endDate,
        title: event.title,
        id: event.id,
        hasPublicRelease: event.hasPublicRelease,
        venue: event.venue,
        timeZone: event.venue?.timezone,
        locale: event.venue?.locale,
      })
    );
  }

  overall.sort((a, b) => Date.parse(a?.startDate) - Date.parse(b?.startDate));

  const toggleSearch = () => setShowSearch(!showSearch);

  return (
    <>
      <Seo title="Event Overview" description={undefined} />
      <Menu>
        <SubHeader
          showSearch={showSearch}
          setSearch={setSearch}
          toggleSearch={toggleSearch}
          hasBackground={!!organization?.branding?.background}
        />
      </Menu>
      <Layout layoutType="main">
        <List
          setSearch={setSearch}
          events={overall}
          featuredEvents={featuredEvents}
        />
      </Layout>
    </>
  );
};

export default Overall;
